import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=be95bcc6&scoped=true"
import script from "./SectionList.vue?vue&type=script&lang=ts"
export * from "./SectionList.vue?vue&type=script&lang=ts"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=be95bcc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be95bcc6",
  null
  
)

export default component.exports